import { useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import io from 'socket.io-client';
import { updateTournamentPlayers } from '../../../../../../../../store/actionCreators/tournamentCasinoPlayers';
import { updateTournamentChat } from '../../../../../../../../store/actionCreators/tournamentCasinoChats';
import { getCurrentClubPlayerToken, getCurrentAccount, getTournamentChatStatuses } from '../../../../../../../../store/selectors';
import { socketUsersToInner } from '../helpers/transform';
import useSocketCallBack from './useSocketCallBack';
import config from '../../../../../../../../config/config';

const socketUrl = config.SOCKET_URL;

const useTournamentSocket = ( onBadBet, onServerMessage, tourId ) => {
  const dispatch = useDispatch();
  const tournamentChatStatuses = useSelector(getTournamentChatStatuses);
  const tournamentChatStatus = tournamentChatStatuses[tourId] ? 
  tournamentChatStatuses[tourId] : false;
  const socket = useRef(null);
  const token = useSelector(getCurrentClubPlayerToken);
  const user = useSelector(getCurrentAccount);
  let id = user ? user.id : null;
  let username = user ? user.username : null;

  const onGetPlayerList = ({ tournamentId, players }) => {
    if (!players) return;
    dispatch(updateTournamentPlayers(tournamentId, players.map(socketUsersToInner(id))));
  };

  const onTournamentChatHistory = useCallback(({ messages}) => {
    if(!messages.length) return; 
    messages.map(m => dispatch(updateTournamentChat(m, tournamentChatStatus)));
  }, [tournamentChatStatus]);

  useEffect(() => {
    if (!socketUrl || !id || !username || !token) return;
    socket.current = io(socketUrl, {
      query: { id, username, token },
    });
    socket.current.on('getTournamentChatHistory', onTournamentChatHistory);
    socket.current.on('getPlayersList', onGetPlayerList);
    socket.current.on('serverMessage', m => onServerMessage(m));
    return () => {
      if (socket.current) socket.current.disconnect(true);
      socket.current = null;
    }
  }, [socketUrl, id, username]);

  const updateChatFn = useCallback(
    m => dispatch(updateTournamentChat(m, tournamentChatStatus)), 
    [tournamentChatStatus]
  );
  useSocketCallBack('newMessage', socket.current, updateChatFn);

  const badBetFn = useCallback(d => onBadBet(d.tournamentId), [onBadBet]);
  useSocketCallBack('badBetWin', socket.current, badBetFn);
  
  const onReconnect = useCallback(() => {
    if (tourId && socket.current) {
      socket.current.emit('joinToGame', { tourId });
      socket.current.emit('getPlayersList', { tourId });
    }
  }, [socket.current, tourId]);
  useSocketCallBack('reconnect', socket.current, onReconnect);

  useEffect(() => {
    if (tourId && socket.current) {
      socket.current.emit('joinToGame', { tourId });
      socket.current.emit('getPlayersList', { tourId });
    }
  }, [tourId]);

  return useCallback((type, params) => {
    if (socket.current) socket.current.emit(type, params);
  }, []);
}

export default useTournamentSocket;